export enum PaymentActionEnum {
  CONFIRM = <any>'confirm',
  REJECT = <any>'reject',
}

export const PaymentActions: string[] = [
  PaymentActionEnum.CONFIRM.toString(),
  PaymentActionEnum.REJECT.toString()
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-action.enum.ts